import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar as MantineAvatar } from "@mantine/core";
import { IconAi, IconKey } from "@tabler/icons-react";
import { forwardRef } from "react";
export const UserAvatar = forwardRef(({ user, size }, ref) => {
    const { avatar, name, id, } = user;
    let src = null;
    if (avatar && id) {
        src = `/api/users/${id}/avatars/${avatar}`;
    }
    return (_jsx(MantineAvatar, { src: src, size: size, ref: ref, name: name }));
});
export const ApiKeyAvatar = forwardRef(({ name, size }, ref) => {
    return (_jsx(MantineAvatar, { size: size, ref: ref, name: name, children: _jsx(IconKey, { size: size }) }));
});
export const AIAssistantAvatar = forwardRef(({ size }, ref) => {
    return (_jsx(MantineAvatar, { size: size, ref: ref, name: "AI Assistant", children: _jsx(IconAi, { size: size }) }));
});
